import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-navy-950 flex items-center justify-center p-6">
          <div className="glass-card max-w-lg w-full p-8 text-center animate-fade-in">
            <div className="w-16 h-16 bg-red-500/20 border border-red-500/30 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <AlertTriangle className="text-red-400 w-8 h-8" />
            </div>
            
            <h1 className="text-2xl font-bold text-white mb-2">Something went wrong</h1>
            <p className="text-gray-400 mb-6 text-sm">
              We encountered an unexpected error. Don't worry, your data is safe.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="text-left bg-navy-900 rounded-lg p-4 mb-6 overflow-auto max-h-40 border border-white/5">
                <p className="text-red-400 font-mono text-xs">{this.state.error.toString()}</p>
                <p className="text-gray-500 font-mono text-xs mt-2 whitespace-pre-wrap">{this.state.errorInfo?.componentStack}</p>
              </div>
            )}

            <button 
              onClick={() => window.location.reload()}
              className="btn-gold flex items-center justify-center gap-2 w-full"
            >
              <RefreshCw size={18} />
              Reload Application
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
